import { useRef, useState } from 'react';
import { usePreview } from 'shared/domains/documents';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { PleditorContext } from './context';
import { tryGetPlugin } from './utils';
import { useSearchTexts } from '../hooks/useSearchTexts';
export function PleditorProvider(props) {
    const { children } = props;
    const { isFreeText } = usePreview();
    const isSandboxEnabled = useFeatureFlag('feature_pleditor_sandbox');
    const [state, setState] = useState('initializing');
    const [editorName, setEditorName] = useState('');
    const [sandbox, setSandbox] = useState(false);
    const pleditorRef = useRef(null);
    const setPleditor = (name, editor) => {
        pleditorRef.current = editor;
        setState('initialized');
        setEditorName(name);
    };
    const unsetPleditor = () => {
        pleditorRef.current = null;
        setState('initializing');
    };
    const sandboxMode = isSandboxEnabled && sandbox && isFreeText;
    const sandboxModeAvailable = isSandboxEnabled && isFreeText;
    const { fuzzySearchTextNodes, resetFuzzySearch } = useSearchTexts(pleditorRef.current);
    const baseValue = {
        setPleditor,
        unsetPleditor,
        sandboxMode,
        sandboxModeAvailable,
        setSandboxMode: setSandbox,
        fuzzySearchTextNodes,
        resetFuzzySearch,
    };
    if (state === 'initialized' && pleditorRef.current !== null) {
        const value = Object.assign(Object.assign({}, baseValue), { pleditorState: state, pleditor: pleditorRef.current, plugins: {
                attachmentStore: tryGetPlugin(pleditorRef.current, 'AttachmentStore'),
                revisionHistory: tryGetPlugin(pleditorRef.current, 'RevisionHistory'),
                versionDiagnostics: tryGetPlugin(pleditorRef.current, 'VersionDiagnostics'),
                trackChanges: tryGetPlugin(pleditorRef.current, 'TrackChanges'),
            }, dev: {
                editorName,
                bundleVersion: process.env.PLEDITOR_BUNDLE_VERSION,
                packageVersion: window.CKEDITOR_VERSION,
            } });
        return <PleditorContext.Provider value={value}>{children}</PleditorContext.Provider>;
    }
    const value = Object.assign(Object.assign({}, baseValue), { pleditorState: 'initializing', pleditor: null, plugins: {}, dev: null });
    return <PleditorContext.Provider value={value}>{children}</PleditorContext.Provider>;
}
export { usePleditor } from './hook';
